import { graphql, useStaticQuery } from "gatsby";

export type IEvent = {
  title: string;
  location: string;
  description: string;
  registration_url: string;
  information_url: string;
  datetime_from: string;
  datetime_to: string;
  is_invite_only: boolean;
};

export type Props = {
  allPortalEvent?: {
    nodes: IEvent[];
  } | undefined;
};

export const useEventData = () => {
  const data: Props = useStaticQuery(
    graphql`
      {
        allPortalEvent(filter: { id: { ne: "dummy" } }) {
          nodes {
            title
            location
            description
            registration_url
            information_url
            datetime_from
            datetime_to
            is_invite_only
          }
        }
      }
    `
  );
  return data?.allPortalEvent?.nodes;
};
